import { ExpansionList, ExpansionPanel, FontIcon } from 'react-md'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import LoadingState from 'ui/components/LoadingState'
import type { Apartment } from 'types/apartment'
import InvoicePaymentProductsTable from './InvoicePaymentProductsTable'
import { useWatch } from 'react-hook-form'
import type { MeterInvoicingRowsByContract } from './types'

const Container = styled.div`
	display: flex;
	flex-flow: column nowrap;
	gap: 1rem;
	margin-top: 1rem;
	margin-bottom: 2rem;
`

const IconCircleContainer = styled.span<{ $backgroundColor: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: ${(props) => props.$backgroundColor};
`
type Props = {
	companyApartments: Apartment[]
	loading?: boolean
}

const InvoiceForm = ({ companyApartments, loading = false }: Props) => {
	const meterInvoicingRowsByContract = useWatch({
		name: 'meterInvoicingRowsByContract',
	})

	return (
		<Container>
			{loading && <LoadingState />}
			{!loading &&
				meterInvoicingRowsByContract &&
				meterInvoicingRowsByContract.length && (
					<ExpansionList style={{ marginBottom: '2rem' }}>
						{meterInvoicingRowsByContract.map(
							(meterReadingInvoiceRow: MeterInvoicingRowsByContract) => {
								const { contract, invoiceRows } = meterReadingInvoiceRow
								const apartment = companyApartments.find(
									(apartment) => apartment.uuid === contract.apartmentUUID,
								)

								if (!apartment) {
									return null
								}
								const { identifier } = apartment
								const status = 'needs_action'

								return (
									<ExpansionPanel
										defaultExpanded
										style={{ padding: '0 1rem 0 1rem' }}
										key={`apartment-panel-${identifier}`}
										footer={null}
										label={
											<div
												style={{
													display: 'flex',
													flexFlow: 'row',
													alignItems: 'center',
													gap: '1rem',
												}}
											>
												{status === 'needs_action' && (
													<IconCircleContainer $backgroundColor="var(--gray-6)">
														<FontIcon
															forceFontSize
															forceSize={20}
															style={{ color: 'white' }}
														>
															priority_high
														</FontIcon>
													</IconCircleContainer>
												)}
												<div>
													<p>
														{identifier} - {contract.partyName}
													</p>
													<div
														style={{
															display: 'flex',
															flexFlow: 'row nowrap',
															gap: '0.25rem',
														}}
													>
														{status === 'needs_action' && (
															<span>
																<FormattedMessage
																	defaultMessage="Tarkista rivit." //TODO:
																	description="Check the rows."
																/>
															</span>
														)}
													</div>
												</div>
											</div>
										}
									>
										<InvoicePaymentProductsTable invoiceRows={invoiceRows} />
									</ExpansionPanel>
								)
							},
						)}
					</ExpansionList>
				)}
		</Container>
	)
}
export default InvoiceForm
